import React from 'react';
import { useEffect, useState } from 'react';
import Spinner from '@shared/Spinner';
import styled from 'styled-components';
import DataTable from './components/Datatable';
import ThresholdsButton from './components/Button';
import { useThresholds } from '@hooks/useThresholds';
import { BUTTON_MAPPING } from './Constants';
import useAPI from '@hooks/useAPI';

const ThresholdsStyle = styled.div`
  width: 50%;
  margin: 20px auto;
`;

const updateThresholdData = (thresholds, configName) => {
  const customer_id = process.env.REACT_APP_CUSTOMER_ID;

  //const thresholds = useAPI('ScreenConsoleApi', `config/${customer_id}/thresholds`, '', false, '', false);

  console.log("hello!");
  let config = [];

  if (thresholds.response) {
    for (let key in thresholds.response[configName]) {
      config.push({
        list: key,
        freetext: thresholds.response[configName][key]['freetext'],
        name: thresholds.response[configName][key]['name'],
      });
    }
  }
  return config;
}

export default function Thresholds({data}) {
  const [configName, setConfigName] = useState('account');
  let screen_types = ["account", "transaction", "gts_transaction"]
  let config = {"account": [], "transaction": [], "gts_transaction": []};
  
  if (data.response) {
    screen_types.forEach(item => {
      for (let key in data.response[item]) {
        config[item].push({
          list: key,
          freetext: data.response[item][key]['freetext'],
          name: data.response[item][key]['name'],
        });
      }
    })

  }
  
  const buttonClickHandler = e => {
    const type = e.target.innerText;
    setConfigName(BUTTON_MAPPING[type]);
  };

  return (
    <ThresholdsStyle>
        <>
          <DataTable thresholds={config} configName={configName}></DataTable>
          <ThresholdsButton
            buttonClickHandler={buttonClickHandler}
            configName={configName}
          ></ThresholdsButton>
        </>
    </ThresholdsStyle>
  );
};
